import { UseFormReturn } from "react-hook-form";
import { Box, Grid } from "@mui/material";
import { AvailabilityPreferences } from "../../utils/types";
import { AsyncAutoCompleteNew } from "../../../async-auto-complete/AsyncAutoCompleteNew";
import { TechnicianField } from "./TechnicianField";
import { isTechnicianFieldDisabled } from "../../utils/utils";


type ServiceData = {
    firstServiceIsReports: boolean | undefined;
    firstServiceIsPsy: boolean | undefined;
    secondServiceIsReports: boolean | undefined;
    secondServiceIsPsy: boolean | undefined;
    selectedServiceFirst: any;
    selectedServiceSecond: any;
    requireConsecutiveSessions: boolean;
    psychologistTreatment: any;
    clientOwnerTreatment: any;
    ageGroupsSelected: any;
    disorderSpecializationSelected: any;
};

type ServicesSelectionProps = {
    entityForm: UseFormReturn<AvailabilityPreferences>;
    serviceData: ServiceData;
};

export const ServicesSelection = ({ entityForm, serviceData }: ServicesSelectionProps) => {
    const {
        firstServiceIsReports,
        firstServiceIsPsy,
        secondServiceIsReports,
        secondServiceIsPsy,
        selectedServiceFirst,
        selectedServiceSecond,
        requireConsecutiveSessions,
        psychologistTreatment,
        clientOwnerTreatment,
        ageGroupsSelected,
        disorderSpecializationSelected,
    } = serviceData;

    return (
        <>
            <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <AsyncAutoCompleteNew
                        entityForm={entityForm as unknown as UseFormReturn}
                        fieldName="firstService"
                        placeholder="Selecione o serviço"
                        enabled={true}
                        recordsOptions={{
                            entity: "services",
                            fieldsToQuery: "*",
                            labelKey: "name",
                            filter: {
                                id: { _neq: 41 },
                            },
                            customFilter: (value: string) => ({
                                name: { _icontains: value },
                            }),
                            sort: "name",
                        }}
                    />
                    {(firstServiceIsReports || firstServiceIsPsy) && selectedServiceFirst ? (
                        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                            <TechnicianField
                                entityForm={entityForm as unknown as UseFormReturn}
                                ageGroupsSelected={ageGroupsSelected?.id}
                                disorderSpecializationSelected={disorderSpecializationSelected?.id}
                                disabled={isTechnicianFieldDisabled(
                                    selectedServiceFirst,
                                    psychologistTreatment,
                                    clientOwnerTreatment
                                )}
                                componentKey={`${selectedServiceFirst.id}-${psychologistTreatment?.id}-${clientOwnerTreatment?.id}`}
                                technicianField="firstServiceTechnician"
                            />
                        </Box>
                    ) : null}
                </Box>
            </Grid>
            {requireConsecutiveSessions && (
                <Grid item xs={12} md={4}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <AsyncAutoCompleteNew
                            entityForm={entityForm as unknown as UseFormReturn}
                            fieldName="secondService"
                            enabled={true}
                            placeholder="Selecione o serviço"
                            recordsOptions={{
                                entity: "services",
                                fieldsToQuery: "*",
                                labelKey: "name",
                                customFilter: (value: string) => ({
                                    name: { _icontains: value },
                                }),
                            }}
                        />
                        {(secondServiceIsReports || secondServiceIsPsy) && selectedServiceSecond ? (
                            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                                <TechnicianField
                                    entityForm={entityForm as unknown as UseFormReturn}
                                    ageGroupsSelected={ageGroupsSelected?.id}
                                    disorderSpecializationSelected={disorderSpecializationSelected?.id}
                                    disabled={isTechnicianFieldDisabled(
                                        selectedServiceSecond,
                                        psychologistTreatment,
                                        clientOwnerTreatment
                                    )}
                                    componentKey={`${selectedServiceFirst.id}-${psychologistTreatment?.id}-${clientOwnerTreatment?.id}`}
                                    technicianField="secondServiceTechnician"
                                />
                            </Box>
                        ) : null}
                    </Box>
                </Grid>
            )}
        </>
    );
};
